import type { RootContextValue } from "#root-context";

export const DEFAULT_WINDOW_DIMENSIONS: RootContextValue["windowDimensions"] = {
  fontScale: 1,
  height: 812,
  scale: 2,
  width: 375,
};

export const DEFAULT_ROOT_CONTEXT_VALUE: RootContextValue = {
  orientation:
    DEFAULT_WINDOW_DIMENSIONS.width > DEFAULT_WINDOW_DIMENSIONS.height ? "landscape" : "portrait",
  windowDimensions: DEFAULT_WINDOW_DIMENSIONS,
};
